import { useClientFetch } from '../../../../context/ClientStatusContext';
import { ClientStatus } from '../../../../model/ClientStatus';
import StadiumMaterialuHistoriaList from '../../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import {
  fetchStadiumMaterialuHistoriaList,
} from '../../../../client/external/evidencnaaplikacia/legislativnyMaterialHistoriaListClient';
import Uuid from '../../../../model/Uuid';

interface ReturnType {
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
  legMaterialHistoriaStatus: ClientStatus;
  reloadLegMaterialHistoriaList
}

export default (legMaterialUuid: Uuid): ReturnType => {
  const {
    data: legMaterialHistoriaList,
    status: legMaterialHistoriaStatus,
    refetch: reloadLegMaterialHistoriaList,
  } = useClientFetch(
    fetchStadiumMaterialuHistoriaList,
    [legMaterialUuid],
    [legMaterialUuid],
  );
  return {
    legMaterialHistoriaList,
    legMaterialHistoriaStatus,
    reloadLegMaterialHistoriaList,
  };
};
